import React from "react";
import Button from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';

function LVButtonReporte({ Ancho, Url, Texto }) {

  const navigate = useNavigate();
  const nuevoClick = () => {
    navigate(Url)
  }

  return (
    <Button
      text={Texto} 
      width={Ancho} 
      type="default" 
      stylingMode="outlined" 
      onClick={nuevoClick} 
      style={{ margin: '0 5px', borderRadius: '8px' }} />
  );
}

export default LVButtonReporte

